import AccountDetailsSymbols from "../symbols/accountDetails";
import { HttpRequestGet } from "../../service";
const accountDetailsAction = () => ({
  type: AccountDetailsSymbols.ACCOUNT_DETAILS,
});
const accountDetailsSuccessAction = (data: any) => ({
  type: AccountDetailsSymbols.ACCOUNT_DETAILS_SUCCESS,
  payload: data,
});
const accountDetailsFailureAction = (data: any) => ({
  type: AccountDetailsSymbols.ACCOUNT_DETAILS_FAILURE,
  payload: data,
});
const clearAccountDetailsAction = () => ({
  type: AccountDetailsSymbols.CLEAR_ACCOUNT_DETAILS,
});

export function getAccountDetails(callback?: any) {
  const url = "/merchant";
  return (dispatch: any) => {
    dispatch(accountDetailsAction());
    HttpRequestGet(
      url,
      dispatch,
      accountDetailsSuccessAction,
      accountDetailsFailureAction,
      true,
      callback
    );
  };
}

export function clearAccountDetails() {
  return (dispatch: any) => {
    dispatch(clearAccountDetailsAction());
  };
}
